jQuery.ajax({
  url: "https://api.ipdata.co?api-key=707d6b4c1028c1a7659278a928ac17764a3e7c232b2745974ea253e5",
  type: "GET",
  dataType: "json",
  success: function (location) {
    const userRegion = location.region;
    const userCountryName = location.country_name;

    // Set global variables for use throughout the theme
    window.userCountry = userCountryName;
    window.userRegion = userRegion;
    window.isUS = userCountryName == "United States" && userRegion != "Alaska";
    window.isCanada = userCountryName == "Canada";
    window.isEU = location.is_eu;

    jQuery("#country-name").html(userCountryName);
    jQuery("#country-name-product").html(userCountryName);
    jQuery("#country-name-product2").html(userCountryName);
    jQuery("#country-name-product3").html(userCountryName);

    if (window.isUS) {
      $(".topbarshipping").show();
      jQuery(".topbarlocation").html(userRegion);
      jQuery("#country-name").html(userRegion);
      jQuery("#country-name-product2").html(userRegion);
      jQuery("#country-name-product3").html(userRegion);
      $(".price__fordiscont").show();
      $(".progressbar__wrapper").show();
    } else if (window.isCanada) {
      $(".topbarshipping").show();
      jQuery(".topbarlocation").html(userRegion);
      jQuery("#country-name").html(userRegion);
      $(".price__fordiscont").show();
      $(".progressbar__wrapper").show();
    }
    
    // Toggle promo banners after geolocation is complete
    if (typeof window.togglePromoBanners === 'function') {
      window.togglePromoBanners();
    }
    // === Promo banner country + link logic ===
    if (window.isUS) {
      // Desktop
      jQuery("#promo-link-desktop").attr(
        "href",
        jQuery("#promo-link-desktop").data("url-us")
      );
      jQuery("#promo-banner-text-desktop").text(
        jQuery("#promo-banner-text-desktop").data("text-us")
      );
    
    
      jQuery("#promo-link-mobile").attr(
        "href",
        jQuery("#promo-link-mobile").data("url-us")
      );
      jQuery("#promo-banner-text-mobile").text(
        jQuery("#promo-banner-text-mobile").data("text-us")
      );
    } else {
 
      jQuery("#promo-link-desktop").attr(
        "href",
        jQuery("#promo-link-desktop").data("url-default")
      );
      jQuery("#promo-banner-text-desktop").text(
        jQuery("#promo-banner-text-desktop").data("text-default")
      );
    
    
      jQuery("#promo-link-mobile").attr(
        "href",
        jQuery("#promo-link-mobile").data("url-default")
      );
      jQuery("#promo-banner-text-mobile").text(
        jQuery("#promo-banner-text-mobile").data("text-default")
      );
    }
    
    if (window.isUS) {
      const now = new Date();
      const options = { weekday: "short", month: "short", day: "numeric" };
    
      const startDate = new Date(now.getTime() + 2 * 86400000); // +10 days
      const endDate = new Date(now.getTime() + 7 * 86400000); // +16 days
    
      const formatted = `${startDate.toLocaleDateString("en-US", options)} - ${endDate.toLocaleDateString("en-US", options)}`;
    
      jQuery("#delivery-estimate").text(formatted);
    } else if (window.isCanada) {
      const now = new Date();
      const options = { weekday: "short", month: "short", day: "numeric" };

      const startDate = new Date(now.getTime() + 2 * 86400000); // +2 days
      const endDate = new Date(now.getTime() + 7 * 86400000); // +7 days

      const formatted = `${startDate.toLocaleDateString("en-US", options)} - ${endDate.toLocaleDateString("en-US", options)}`;

      jQuery("#delivery-estimate").text(formatted);
    } else if (window.isEU) {
      const now = new Date();
      const options = { weekday: "short", month: "short", day: "numeric" };

      const startDate = new Date(now.getTime() + 2 * 86400000); // +2 days
      const endDate = new Date(now.getTime() + 5 * 86400000); // +5 days

      const formatted = `${startDate.toLocaleDateString("en-US", options)} - ${endDate.toLocaleDateString("en-US", options)}`;

      jQuery("#delivery-estimate").text(formatted);
    }
// === Override shipping USP text based on geo ===
const $deliveryUSP = jQuery(".usp-flex-item:first .product_features_container_content p:nth-of-type(2)");

if (window.isUS) {
  // Change "2-5 business days" to "10-16 business days" for US
  $deliveryUSP.text(
    "We exclusively ship all orders with insured express delivery to ensure all orders arrive in only 2-7 business days."
  );
}else if (window.isCanada) {
  $deliveryUSP.text(
    "We exclusively ship all orders with insured express delivery to ensure all orders arrive in only 2-7 business days."
  );
} else {
  // Reset to default for all other countries
  $deliveryUSP.text(
    "We exclusively ship all orders with insured express delivery to ensure all orders arrive in only 2-5 business days."
  );
}

if (window.isCanada) {
 // console.log("Canada detected, swapping hero images...");
  const $hero = jQuery("#hero-picture");

  // Swap desktop images
  const canadaImg = $hero.attr("data-img-canada");
  // console.log("Canada desktop image URL:", canadaImg);
  if (canadaImg) {
    // Update desktop source elements with Canada image
    $hero.find("source[media='(min-width: 768px)']").attr("srcset", 
      `${canadaImg.replace('width: 1800', 'width: 1800')} 1800w, ` +
      `${canadaImg.replace('width: 1800', 'width: 1400')} 1400w, ` +
      `${canadaImg.replace('width: 1800', 'width: 1000')} 1000w`
    );
    
    // Update fallback <img> src
    $hero.find("img").attr("src", canadaImg);
    // console.log("Desktop images swapped successfully");
  } else {
    // console.log("No Canada desktop image found");
  }

  // Swap mobile images
  const canadaMobile = $hero.attr("data-mobile-img-canada");
  // console.log("Canada mobile image URL:", canadaMobile);
  if (canadaMobile) {
    // Update mobile source elements with Canada mobile image
    $hero.find("source[media='(max-width: 767px)']").attr("srcset", 
      `${canadaMobile.replace('width: 800', 'width: 1200')} 1200w, ` +
      `${canadaMobile} 800w, ` +
      `${canadaMobile.replace('width: 800', 'width: 400')} 400w`
    );
    //console.log("Mobile images swapped successfully");
  } else {
    // console.log("No Canada mobile image found");
  }
}




  },
  error: function () {
    console.error("Error fetching location data");
    // Set defaults if geolocation fails
    window.userCountry = "Unknown";
    window.userRegion = "";
    window.isUS = false;
    window.isCanada = false;
    window.isGermany = false;
    window.isEU = false;
  },
});
